var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.813 3.347c-.355-.604-1.27-.604-1.626 0L1.87 10.68c-.33.563.071 1.314.813 1.314h8.634c.742 0 1.144-.751.813-1.314L7.813 3.347zm-2.531-.533c.762-1.294 2.674-1.294 3.436 0l4.317 7.334c.774 1.315-.226 2.896-1.718 2.896H2.683c-1.492 0-2.492-1.581-1.718-2.896l4.317-7.334zM7 4.644c.29 0 .525.235.525.525v2.45a.525.525 0 11-1.05 0v-2.45c0-.29.235-.525.525-.525zm0 4.2c.29 0 .525.235.525.525v1.05a.525.525 0 11-1.05 0v-1.05c0-.29.235-.525.525-.525z",
    fill: "#fff"
  })));
}
export default SvgTimelineError;